import { BrowserModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './core/auth/authentication.module';
import { NgxPermissionsModule } from 'ngx-permissions';
import { LayoutModule } from './content/layout/layout.module';
import { PartialsModule } from './content/partials/partials.module';
import { CoreModule } from './core/core.module';
import { AclService } from './core/services/acl.service';
import { LayoutConfigService } from './core/services/layout-config.service';
import { MenuConfigService } from './core/services/menu-config.service';
import { PageConfigService } from './core/services/page-config.service';
import { UserService } from './core/services/user.service';
import { UtilsService } from './core/services/utils.service';
import { ClassInitService } from './core/services/class-init.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GestureConfig, MatProgressSpinnerModule } from '@angular/material';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MessengerService } from './core/services/messenger.service';
import { ClipboardService } from './core/services/clipboard.sevice';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LayoutConfigStorageService } from './core/services/layout-config-storage.service';
import { LogsService } from './core/services/logs.service';
import { QuickSearchService } from './core/services/quick-search.service';
import { SubheaderService } from './core/services/layout/subheader.service';
import { HeaderService } from './core/services/layout/header.service';
import { MenuHorizontalService } from './core/services/layout/menu-horizontal.service';
import { MenuAsideService } from './core/services/layout/menu-aside.service';
import { LayoutRefService } from './core/services/layout/layout-ref.service';
import { SplashScreenService } from './core/services/splash-screen.service';
import { DataTableService } from './core/services/datatable.service';
import { AddAuthorizationInterceptor } from './core/interceptors/add-authorization-interceptor.service';
import { MatDatepickerModule, MatInputModule, MatNativeDateModule } from '@angular/material';
import { PopupManagementModule } from '../app/content/popup-management/popup-management.module';
import { ToastrModule } from 'ngx-toastr';
import 'hammerjs';
import { InfoComponent } from './component/info-page/info/info.component';
import { HttpUtilsService } from './content/pages/components/_core/utils/http-utils.service';
import { ResetPasswordComponent } from './content/pages/auth/reset-password/reset-password.component';
import { VerifyAccountComponent } from './content/pages/auth/verify-account/verify-account.component';
import { LoginAsComponent } from './content/pages/auth/login-as/login-as.component';
import { AppService } from './content/pages/components/_shared/app.service';
import { TranslationService } from './core/services/translation.service';
import { CustomPaginatorIntl } from './core/services/custom-paginator-intl.service';
import { MatPaginatorIntl } from '@angular/material';

// Factory function to load translations before app starts
export function initializeTranslations(translationService: TranslationService) {
	return () => translationService.loadLanguage();
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
};

@NgModule({
	declarations: [AppComponent, InfoComponent, ResetPasswordComponent, VerifyAccountComponent, LoginAsComponent],
	imports: [
		BrowserAnimationsModule,
		BrowserModule,
		AppRoutingModule,
		HttpClientModule,
		LayoutModule,
		PartialsModule,
		CoreModule,
		OverlayModule,
		AuthenticationModule,
		NgxPermissionsModule.forRoot(),
		NgbModule.forRoot(),
		TranslateModule.forRoot(),
		MatProgressSpinnerModule,
		MatDatepickerModule, MatInputModule, MatNativeDateModule,
		FormsModule,
		ReactiveFormsModule,
		ToastrModule.forRoot({
			timeOut: 3000,
			positionClass: 'toast-top-center',
			preventDuplicates: true,
		}),
		PopupManagementModule,

	],
	providers: [
		AclService,
		LayoutConfigService,
		LayoutConfigStorageService,
		LayoutRefService,
		MenuConfigService,
		PageConfigService,
		UserService,
		AppService,
		UtilsService,
		ClassInitService,
		MessengerService,
		ClipboardService,
		LogsService,
		QuickSearchService,
		DataTableService,
		HttpUtilsService,
		SplashScreenService,
		TranslationService,
		{
			provide: APP_INITIALIZER,
			useFactory: initializeTranslations,
			deps: [TranslationService],
			multi: true
		},

		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		SubheaderService,
		HeaderService,
		MenuHorizontalService,
		MenuAsideService,
		{
			provide: HAMMER_GESTURE_CONFIG,
			useClass: GestureConfig
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AddAuthorizationInterceptor,
			multi: true,
		},
		{
			provide: MatPaginatorIntl,
			useClass: CustomPaginatorIntl,
			deps: [TranslationService]
		}
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	bootstrap: [AppComponent]
})
export class AppModule {
}
